//Componentes generales
import React, { useReducer,useEffect, useRef, useInsertionEffect, useContext } from "react";
import productsReducer from "./productsReducer";
import productsContext from "./productsContext";

//Axios
import clienteAxios from "../../config/axios";

//Rutas de api
import { getAbmProduct, getDataByProd, updateProduct, uploadAbmProduct, uploadProduct } from "../../api/abmProduct.js"

import { getProductsFromCons } from "../../api/product.js";

//Acciones
import { 
    ACTUALIZAR_PRODUCTOS,
    ACTUALIZAR_PRODUCTOS_DB,
    CARGANDO_PROD,
    ERROR_PROD,
    FINALIZAR_CARGA_PROD,
    LIMPIAR_ERROR
} from "./productsAction";

import { SocketContext } from "../socket/socket.js";
import authContext from "../authentication/authContex.js";


/* 
    State encargado de la gestión de productos.
*/
const ProductsState = props => {

    //Valores iniciales
    const initialState = {
        products: [],
        cargando: false,
        error: ""
    };
    
    const server = useContext(SocketContext);
    const [state, dispatch] = useReducer(productsReducer, initialState);
    const productsRef = useRef(state.products);
    const auContext = useContext(authContext);
    const {usuario} = auContext;

    /* 
        Función recuperar los productos y a su vez actualizarlos.
    */
    const actualizarProducts = async () => {
        try{
            const resp = await getAbmProduct();
            dispatch({
                type: ACTUALIZAR_PRODUCTOS,
                payload: resp.data.data
            })
            productsRef.current = resp.data.data;
            return resp.data.data;
        }catch(error){
            console.log(error);
        }
    }

    /* 
        Función encargada de sobreescribir la base de datos de productos con la propia de Softland.
            Donde userID es el ID del usuario en sesión.
                  userName es el nombre del usuario en sesión.
    */
    const actualizarProductsDB = async (userID, userName) => {
        try{
            console.log("ENTRO AL ACTUALIZAR PRODUCTOS");
            await uploadAbmProduct(userID, userName);
            const resp = await getAbmProduct();

            dispatch({
                type: ACTUALIZAR_PRODUCTOS_DB,
                payload: resp.data.data
            });

            return {status: true, msg: "Se actualizo con éxito la base de datos."};

        }catch(error){
            console.log(error);
            dispatch({
                type: ERROR_PROD,
                payload: error.response.data.errMsg
            });

            return {status: false, msg: error.response.data.errMsg};
        }
    }

    const cargando =  () => {
        dispatch({
            type: CARGANDO_PROD
        })
    }

    const finalizarCarga =  () => {
        dispatch({
            type: FINALIZAR_CARGA_PROD
        })
    }

    const limpiarError = () => {
        dispatch({
            type: LIMPIAR_ERROR
        })
    }

    const getProductsFromConsumo = async(tDoc) => {
        try {
            const resp = await getProductsFromCons(tDoc);
            if(resp.status == 200 && resp.data.products){
                if(resp.data.products.length > 0) return {productos:resp.data.products, obtenidos: true, msg:'Productos obtenidos exitosamente!'}
                else return {obtenidos: false, msg: 'No existen Consumos Reales asociado a la ODT'}
            }else{
                return {obtenidos: false, msg: 'Hubo un error al comunicarse con el servidor'}
            }
        } catch (error) {
            console.log("error en getProductsFromConsumo");
            console.log(error);
            return {obtenidos: false, msg: error.response.data.message};
        }
    }

    const uploadProducto = async(product) => {
        try {
            let res = await uploadProduct(product);
            return res;
        } catch (error) {
            console.log("error en uploadProducto de productsState");
            console.log(error);
            return false;
        }
    }
    const updateProducto = async(product) => {
        try {
            let res = await updateProduct(product);
            return res;
        } catch (error) {
            console.log("error en updateProduct de productsState");
            console.log(error);
            return false;
        }
    }

    const getDataByProduct = async(product, periodo) => {
        try {
            console.log("product");
            console.log(product);
            
            let res = await getDataByProd(product.tippro, product.artcod, periodo);
            if(res.data?.data){
                return res.data.data
            }else return false;
        } catch (error) {
            console.log("error en getDataByProduct en productsState");
            console.log(error);
            
        }
    }

    useEffect(()=>{
        if(usuario != null) actualizarProducts();
    },[usuario])

     useEffect(() => {
            if(server){
                server.on('newProduct', () =>{
                    actualizarProducts();
                })
               
                server.on('productUpdated', ({product}) =>{
                    if(Array.isArray(productsRef.current) && productsRef.current.length > 0 && product){
                            let productsList = productsRef.current.slice();
                            productsList.forEach((p,i) => {
                                if(p._id == product._id) productsList[i] = product;
                            })
                            productsRef.current = productsList;
                        dispatch({
                            type: ACTUALIZAR_PRODUCTOS,
                             payload: productsList
                        });
                    }
                })
    
                return () => {
                    server.off('newProduct');
                    server.off('productUpdated');
                }
            }
    }, [server]);

    return(
        <productsContext.Provider
            value={{
                products: state.products,
                isCargando: state.cargando,
                error: state.error,
                actualizarProducts,
                actualizarProductsDB,
                cargando,
                finalizarCarga,
                limpiarError,
                getProductsFromConsumo,
                uploadProducto,
                updateProducto,
                getDataByProduct
            }}
        >

            {props.children}

        </productsContext.Provider>
    )
    
}

export default ProductsState;